import { Persona } from '@app/persona/models';
import { dasherize } from '@app/utils/strings';
import { PersonaUITypes } from '@app/persona/constants/constants';

export const personaImagesMap = {
    'agriculture': 'cow',
    'horticulture': 'wheat',
    'industry-and-manufacturing': 'industry-windows',
    'facilities-management': 'gear',
    'household': 'house-chimney-sharp',
    'lifestyle-block': 'fence',
    'environmental-monitoring': 'droplet',
    'beekeeping': 'bee',
    'honey': 'bee',
    'food-safety-and-nutrition': 'fork-knife'
};

export const personaIconMap = {
    'everyone': 'team',
};

export interface PersonaUI {
    title: string;
    icon?: string;
    imgSrc?: string;
    imgSrcOutline: string;
    id: number;
    type: PersonaUITypes;
    longText?: boolean;
}

export const assetPath = '/assets/persona/icons';
export const toOutlinePath = key => `${assetPath}/${!!key ? `${key}-light` : 'ellipsis-light'}.svg`;
export const toPersonaUIBuilder = (images, icons) => ({ organisationGroupId: id, name: title, type }: Persona): PersonaUI => ({
    id,
    title,
    icon: icons[dasherize(title)],
    imgSrc: toOutlinePath(images[dasherize(title)]),
    imgSrcOutline: toOutlinePath(images[dasherize(title)]),
    type: type === PersonaUITypes.PERSONA ? PersonaUITypes.PERSONA : PersonaUITypes.FILTER,
    longText: title.length > 15
});
export const toPersonaUI = toPersonaUIBuilder(personaImagesMap, personaIconMap);
export const personaUIComparator =   (o1: PersonaUI, o2: PersonaUI) => !!o1 && !!o2 ? o1.id === o2.id : o1 === o2;
